var map = {
	"./01_hero_desktop.jpg": 372,
	"./01_hero_mobile.jpg": 373,
	"./01_hero_tablet.jpg": 374,
	"./BBC_ProjectReith_WorldNews_Tile_Red_RGB.svg": 375,
	"./BBC_ProjectReith_WorldNews_Tile_Red_RGB@2x.png": 376,
	"./followthefood_logo.svg": 377,
	"./hub_twitter_image.jpg": 378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;